import { useParams } from 'react-router-dom';

import { useStudentDashboard } from '@/data/context/StudentDashboardContext';
import { ROUTES } from '@/utils/routes';

export default function useCourseLessonsHref() {
  const { slugCourseName = '', klassId } = useParams();
  const { activeCourseProgress } = useStudentDashboard();

  return ROUTES.COURSES.INFO(
    activeCourseProgress?.coursePath.slug ?? slugCourseName,
    activeCourseProgress?.klassId ?? klassId,
  );
}
